<template>
  <div style="height: 100vh">
    <KeyboardEvents @keyup="keyboardEvent" />
    <Loading
      :active.sync="$store.getters.isLoading"
      :can-cancel="false"
      :height="32"
      :is-full-page="true"
      :width="32"
    />

    <!-- /.login-logo -->
    <b-row
      class="h-100"
      style="background: #f4f6f9"
    >
      <b-col
        align-self="center"
        lg="4"
        md="12"
      >
        <div class="login-div">
          <div class="login-logo mb-3">
            <img
              alt="TENACY"
              class="logo-login-img"
              :src="`${publicPath}static/img/Tenacy_couleur_borderless.svg`"
            />
          </div>

          <form @submit.prevent.stop="$emit('dummy')">
            <FormField
              v-model="emailInput"
              :error="emailError"
              :label="_('Email')"
              name="email"
              no-check
              placeholder="john.doe@example.com"
              type="text"
              @blur="emailOnBlur"
            />
            <b-row>
              <b-col xs="12">
                <b-button
                  class="w-100 login-button tenacy-btn ripple"
                  :disabled="recaptcha_token === ''"
                  variant="primary"
                  @click.stop="resetPassword"
                >
                  <translate>Send reset instructions</translate>
                </b-button>
              </b-col>
            </b-row>
          </form>
          <b-row class="mt-3">
            <b-col class="text-center">
              <a
                href="#"
                @click="$router.push('/login')"
              >
                <translate>Sign in</translate>
              </a>
            </b-col>
          </b-row>
        </div>
      </b-col>
      <AuthColRight class="hide-col" />
    </b-row>
  </div>
</template>

<script>
import Loading from 'vue-loading-overlay'
import FormField from '@/components/ui/FormField.vue'
import UnauthPageMixin from '@/mixins/UnauthPageMixin'
import KeyboardEvents from '@/components/ui/KeyboardEvents.vue'
import AuthColRight from '@/components/ui/AuthColRight.vue'
import { isLanguageFrench } from '@/helpers/Language.helpers'
import { config } from '@/config.settings'
import { useFormValidation } from '@/contexts/shared/form-validation/UseFormValidation.composables'
import { ValidateOn } from '@/contexts/shared/form-validation/FormValidation.interfaces'
import { emailSchema } from '@/contexts/authentication/ForgotPasswordView.helpers'

export default {
  name: 'ForgotPasswordView',
  components: {
    KeyboardEvents,
    FormField,
    Loading,
    AuthColRight,
  },
  mixins: [UnauthPageMixin],
  setup() {
    const {
      validators: {
        email: { input: emailInput, error: emailError, onBlur: emailOnBlur },
      },
      validate,
      valid,
    } = useFormValidation(
      {
        email: {
          schema: emailSchema(),
          value: '',
        },
      },
      { validateOn: ValidateOn.BLUR }
    )

    return {
      emailInput,
      emailError,
      emailOnBlur,
      validateForm: validate,
      isFormValid: valid,
    }
  },
  data: function () {
    return {
      recaptcha_token: '',
      publicPath: import.meta.env.BASE_URL,
    }
  },
  mounted() {
    if (isLanguageFrench()) {
      this.$language.current = 'fr_FR'
    } else {
      this.$language.current = 'en_US'
    }
  },
  methods: {
    resetPassword: async function () {
      const _this = this
      const email = this.emailInput
      const recaptcha_token = this.recaptcha_token

      this.$log.debug(recaptcha_token, email)

      await this.validateForm()
      if (!this.isFormValid) {
        return
      }

      this.$store.commit('loading')
      this.$http
        .post(config.base_url + '/auth/password/forgot', {
          email,
          recaptcha_token,
        })
        .then((resp) => {
          if (resp.data.ok) {
            _this.$store.commit('unloading')
            _this.$router.push('/login')
            _this.$toast.info(resp.data.message)
          } else {
            throw new Error(resp.data.message)
          }
        })
        .catch((err) => {
          _this.$store.commit('unloading')
          _this.$log.debug(err)
          _this.$toast.info(err.message)
        })
    },
    keyboardEvent(e) {
      if (e.which === 13) {
        this.resetPassword()
      }
    },
  },
}
</script>
